<script>
  export let name;
  export let values;
  export let value;

  if (name === "Medium" || name === "Company" || name === "Quality") {
    values = values.map( value => { return { value: value, text: value} });
  }

  if (values.includes("staining")) {

    values = values.sort( ( a, b ) => {
      if(a === "All") {
        return 0;
      }

      if( a < b) {
        if (a === "non" && b === "semi") {
          return -1;
        }
        return 1;
      }

      if ( a > b ) {
        return -1;
      }

      return 0;
    })

    values = values.map( value => {
      if ( value === "non") {
        return { value: value, text: "not staining"};
      } else if (value === "semi"){
        return { value: value, text:"semi staining"};
      } else {
        return { value: value, text: value } ;
      }
    })
  }

  if (values.includes("granulating")) {

    values = values.sort( ( a, b ) => {
      if( a < b) {
        if (a === "non" && b === "semi") {
          return 1;
        }
        return -1;
      }

      if ( a > b ) {


        return 1;
      }

      return 0;
    })

    values = values.map( value => {
      if ( value === "non" ) {
        return { value: value, text: "not granulating"};
      } else if (value === "semi"){
        return { value: value, text:"semi granulating"};
      } else {
        return { value: value, text: value } ;
      }
    })
  }

  if (values.includes("transparent")) {
    values = values.map( value => {
      if ( value === "semi") {
        return { value: value, text: "semi transparent"};
      } else {
        return { value: value, text: value } ;
      }
    })
  }
</script>

<!-- Markup -->
<div class="my-2">
  <!-- Caption -->
  <label class="block w-full text-silver text-sm">
    { name }
  </label>

  <!-- Select box -->
  <div class="relative w-full">

    <!-- ArrowIcon -->
    <div class="absolute inset-y-0 right-0 flex items-center">
      <svg class="w-2 h-2 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412 232">
        <path d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z" fill="#648299" fill-rule="nonzero"/>
      </svg>
    </div>

    <!-- Options -->
    <select class="appearance-none
                   border
                   border-smoke
                   rounded-lg
                   px-2
                   py-2
                   w-full
                   bg-white
                   text-silver
                   hover:border-teal
                   hover: outline-none
                   focus: outline-none
                   dark:bg-slate
                   dark:border-slate"
            bind:value on:change>
      {#each values as value}
        <option value="{ value.value }">{ value.text}</option>
      {/each}
    </select>
  </div>
</div>
